// Service Accordian
let questions = document.querySelectorAll(".service-info-heading--wrapper");
questions.forEach(question => {
    question.addEventListener("click", event => {
        const active = document.querySelector(".service-info-heading--wrapper.active");
        if (active && active !== question) {
            active.classList.toggle("active");
            active.nextElementSibling.style.maxHeight = 0;
            active.nextElementSibling.classList.remove("open-accordian");
            active.closest(".service-info-box").classList.remove("active-box");
        }
        question.classList.toggle("active");
        const answer = question.nextElementSibling;
        if (question.classList.contains("active")) {
            answer.style.maxHeight = "max-content";
            answer.classList.add("open-accordian");
            question.closest(".service-info-box").classList.add("active-box");
        } else {
            answer.style.maxHeight = 0;
            answer.classList.remove("open-accordian");
            question.closest(".service-info-box").classList.remove("active-box");
        }
    });
});

// Counter
document.addEventListener("DOMContentLoaded", function() {
    const counters = document.querySelectorAll(".counter");

    function countUp(counter) {
        const targetValue = parseInt(counter.getAttribute("data-target"));
        let currentValue = 0;
        const increment = targetValue / 100;

        const counterInterval = setInterval(() => {
            currentValue += increment;
            if (currentValue >= targetValue) {
                currentValue = targetValue;
                clearInterval(counterInterval);
            }
            counter.textContent = Math.round(currentValue);
        }, 20);
    }

    function checkScroll() {
        counters.forEach(counter => {
            const rect = counter.getBoundingClientRect();
            const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
            if (isVisible && !counter.classList.contains("counted")) {
                counter.classList.add("counted");
                countUp(counter);
            }
        });
    }
    window.addEventListener("scroll", checkScroll);
    checkScroll();
});


// Partner Slider
let swiperInstance;
function initSwiper() {
  if (window.innerWidth > 767) {
    // Initialize Swiper if it hasn't been initialized
    if (!swiperInstance) {
      swiperInstance = new Swiper('.partner-slider', {
        // Swiper configuration
        slidesPerView: 4,
        spaceBetween: 40,
        speed:10000,
        direction: 'horizontal',
        autoplay: 
        {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        loop: true,
        allowTouchMove: false, // optional
      });
    }
  } else {
    // Destroy Swiper if initialized
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null; // Reset the instance
    }
  }
}

// Check on load and resize
initSwiper();
window.addEventListener('resize', initSwiper);

// Latest Post Slider
let postswiperInstance;
function postinitSwiper() {
  if (window.innerWidth > 767) {
    // Initialize Swiper if it hasn't been initialized
    if (!postswiperInstance) {
      postswiperInstance = new Swiper('.latest-post-slider', {
        // Swiper configuration
        slidesPerView: 3,
        spaceBetween: 40,
        navigation: {
          nextEl: ".post-slide-next",
          prevEl: ".post-slide-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
        },
      });
    }
  } else {
    // Destroy Swiper if initialized
    if (postswiperInstance) {
      postswiperInstance.destroy(true, true);
      postswiperInstance = null; // Reset the instance
    }
  }
}
// Check on load and resize
postinitSwiper();
window.addEventListener('resize', postinitSwiper);

// Footer Newsletter
document.addEventListener("DOMContentLoaded", function () {
  const checkbox = document.querySelector(".checkbox");
  const labelText = document.querySelector(".method-switch-btn p");
  const formDiv = document.querySelector("#ContactForm");

  checkbox.addEventListener("change", function () {
    if (this.checked) {
      labelText.textContent = "Phone";
      formDiv.classList.add("show-phone-field");
      document.getElementById("ContactForm-email").value = "noreply@example.com";
    } else {
      labelText.textContent = "Email";
      formDiv.classList.remove("show-phone-field");
      document.getElementById("ContactForm-email").value = "";
    }
  });
});

// Mobile Menu Drawer Custom Close
document.addEventListener('DOMContentLoaded', function () {
  const closeButton = document.querySelector('.menu-drawer-close-btn');
  const menuButton = document.querySelector('.header__icon--menu');
  if (closeButton && menuButton) {
    closeButton.addEventListener('click', function () {
        menuButton.click();
    });
  }
});

// Menu Drawer
document.addEventListener("DOMContentLoaded", function() {
  const menuButton = document.querySelector('.header__icon--menu');
  if (menuButton) {
    menuButton.addEventListener('click', function () {
      document.querySelector('.header--middle-left').classList.toggle('open-menuDrawer');
    });
  }
});


// Related Collection Slider
var swiper = new Swiper(".related-collection-slider", {
  slidesPerView: 3,
  spaceBetween: 40,
  navigation: {
    nextEl: ".collection-slider-next",
    prevEl: ".collection-slider-prev",
  },
  breakpoints: {
    0:{
      slidesPerView: 1,
      spaceBetween: 20,
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 40,
    },
  },
});